import { render, staticRenderFns } from "./AgencyProjectListView.vue?vue&type=template&id=4f94fa65&scoped=true&"
import script from "./AgencyProjectListView.vue?vue&type=script&lang=js&"
export * from "./AgencyProjectListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f94fa65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
installComponents(component, {VAlert})
